import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { GroupSharingService } from '../group-sharing.service.component';

@Component({
  selector: 'app-join-group-popup',
  templateUrl: './join-group-popup.component.html',
  styleUrls: ['./join-group-popup.component.scss']
})
export class JoinGroupPopupComponent implements OnInit, OnChanges {
  meetingId: any;
  name: any;
  // token:any;
  eventsList: any=[];
  @Input() eventId: any;
  @Output() token = new EventEmitter();
  @Input() eventSelected: boolean;
  constructor(
    public groupSharingService: GroupSharingService,
    private toast: HotToastService
  ) { }
  // /public dialogRef: MatDialogRef<GroupSharingComponent>
  // @Optional() @Inject(MAT_DIALOG_DATA) public data:any
  ngOnInit(): void {
    // this.getToken();
    this.getActiveParties();
    this.groupSharingService.socketObservable.subscribe((res) => {
      if (res && res != undefined && Object.keys(res).length != 0) {
        this.getActiveParties()
      }

    })

    this.groupSharingService.joinFromInvite$.subscribe((res) => {
      if (res && res != undefined) {
        this.eventId = res.eventId;
        console.log(this.eventId,'event ID before')
        this.meetingId = res.roomId;
        if (!this.meetingId) {
          console.error("Meeting ID not found, preventing auto-rejoin.");
          return;
      }
        console.log(this.meetingId, 'meeting id'); 
        this.joinGroupEventInvite(res);
      }
    })
  }

  closeDialog() {
    //  this.dialogRef.close()
  }

  joinGroup() {
    //this.dialogRef.close({meetingId: this.meetingId, token: this.token, entryRequested: true})
  }

  getToken() {
    this.groupSharingService.getTokenForOtherParticipants().subscribe((res) => {
      //  this.token = res.token;
    })
  }

  getActiveParties() {

    this.eventsList=[]
    this.groupSharingService.getActiveWatchParty(this.eventId).subscribe((res) => {
console.log(res,'join button logs')
      let item: any = '';
      if (localStorage.getItem('userData')) {
        item = JSON.parse(localStorage.getItem('userData'))
      }
      // res.forEach(element => {
      //   if (element.participants.find((v) => v.userId === item.userId && v.status !== 'DELETED')) {
      //     this.eventsList.push(element)
      //   }
      // });

      this.eventsList = res.filter((element, index, self) =>
        element.participants.some((v) => v.userId === item.userId && v.status !== 'DELETED') &&
        index === self.findIndex((e) => e.id === element.id) // Ensure uniqueness by checking id
      );

      //this.getParticipantToken();
    }, err => {

    })
  }

  getParticipantToken(item) {
    console.log(item,'get participant logs')
    console.log(this.eventId,'from join popup')
    this.groupSharingService.getParticipantToken(this.eventId, item.customRoomId).subscribe((res) => {
      console.log(res,"inside token")
      console.log(this.eventId, "after token")
      //this.eventsList = res;
      if (!res?.token) {
        console.error("Error: Token is undefined", res);
      } else {
        console.log("into else token")
        this.token?.emit({ 
          token: res.token, 
          roomId: this.meetingId, 
          eventId: this.eventId, 
          customRoomId: item.customRoomId 
        });
      }
      // this.token.emit({ token: res.token, roomId: this.meetingId, eventId: this.eventId, customRoomId: item.customRoomId });
    }, err => {

    })
  }

  joinGroupEvent(item) {
    navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
      this.meetingId = item.roomId;
      this.getParticipantToken(item);
      this.eventSelected = true;
    }).catch((err) => {
      console.error(`you got an error: ${err}`)
      this.toast.show(`Please allow Camera and Microphone to start the group sharing on spotlight.`, {
        theme: 'snackbar',
        position: 'top-right',
        duration: 5000
      })

    });

    // this.joinGroup()
  }
  joinGroupEventInvite(item) {
    navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
      this.getParticipantToken(item);
      this.eventSelected = true;
    }).catch((err) => {
      console.error(`you got an error: ${err}`)
      this.toast.show(`Please allow Camera and Microphone to start the group sharing on spotlight.`, {
        theme: 'snackbar',
        position: 'top-right',
        duration: 5000
      })

    });
  }

  ngOnChanges(changes:SimpleChanges){

  }

  ngOnDestroy(): void {
    this.groupSharingService.joinFromInvite$.unsubscribe();
  }
}
